import usersService from "@/services/usersService";

const state = () => ({
  all: []
});

const actions = {
  async findAll({ commit, dispatch }) {
    try {
      const res = await usersService.findAll();
      commit("setUsers", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch("common/showError", "Benutzer konnten nicht geladen werden.", {
        root: true
      });
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await usersService.delete({ id });
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch("common/showError", "Benutzer konnten nicht gelöscht werden.", {
        root: true
      });
      return Promise.reject();
    }
  },
  async update({ dispatch }, { id, isActive }) {
    try {
      await usersService.update({ id, isActive });
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Der Benutzer konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  }
};

const getters = {};

const mutations = {
  setUsers(state, users) {
    state.all = users;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
